// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { GetPalioDataData, GetPalioDataResponses, GetLeaderboardDataData, GetLeaderboardDataResponses, GetPalioGamesStatusData, GetPalioGamesStatusResponses, GetAvailableYearsData, GetAvailableYearsResponses, GetPalioDataByYearData, GetPalioDataByYearResponses, GetPalioDataByYearErrors, GetLeaderboardDataByYearData, GetLeaderboardDataByYearResponses, GetLeaderboardDataByYearErrors, GetPalioGamesStatusByYearData, GetPalioGamesStatusByYearResponses, GetPalioGamesStatusByYearErrors, ServeRootGetData, ServeRootGetResponses, ServeReactAppFullPathGetData, ServeReactAppFullPathGetResponses, ServeReactAppFullPathGetErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Palio Data
 * Returns the complete palio.json data
 */
export const getPalioData = <ThrowOnError extends boolean = false>(options?: Options<GetPalioDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPalioDataResponses, unknown, ThrowOnError>({
        url: '/api/palio',
        ...options
    });
};

/**
 * Get Leaderboard Data
 * Returns the leaderboard.json data
 */
export const getLeaderboardData = <ThrowOnError extends boolean = false>(options?: Options<GetLeaderboardDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLeaderboardDataResponses, unknown, ThrowOnError>({
        url: '/api/leaderboard',
        ...options
    });
};

/**
 * Get Palio Games Status
 * Returns the palio_games_status.json data
 */
export const getPalioGamesStatus = <ThrowOnError extends boolean = false>(options?: Options<GetPalioGamesStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPalioGamesStatusResponses, unknown, ThrowOnError>({
        url: '/api/palio_games_status',
        ...options
    });
};

/**
 * Get Available Years
 * Returns a list of available years with archived data
 */
export const getAvailableYears = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableYearsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAvailableYearsResponses, unknown, ThrowOnError>({
        url: '/api/years',
        ...options
    });
};

/**
 * Get Palio Data By Year
 * Returns the palio.json data for a specific year
 */
export const getPalioDataByYear = <ThrowOnError extends boolean = false>(options: Options<GetPalioDataByYearData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPalioDataByYearResponses, GetPalioDataByYearErrors, ThrowOnError>({
        url: '/api/palio/{year}',
        ...options
    });
};

/**
 * Get Leaderboard Data By Year
 * Returns the leaderboard.json data for a specific year
 */
export const getLeaderboardDataByYear = <ThrowOnError extends boolean = false>(options: Options<GetLeaderboardDataByYearData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLeaderboardDataByYearResponses, GetLeaderboardDataByYearErrors, ThrowOnError>({
        url: '/api/leaderboard/{year}',
        ...options
    });
};

/**
 * Get Palio Games Status By Year
 * Returns the palio_games_status.json data for a specific year
 */
export const getPalioGamesStatusByYear = <ThrowOnError extends boolean = false>(options: Options<GetPalioGamesStatusByYearData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPalioGamesStatusByYearResponses, GetPalioGamesStatusByYearErrors, ThrowOnError>({
        url: '/api/palio_games_status/{year}',
        ...options
    });
};

/**
 * Serve Root
 * Serve the React app at the root path
 */
export const serveRootGet = <ThrowOnError extends boolean = false>(options?: Options<ServeRootGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServeRootGetResponses, unknown, ThrowOnError>({
        url: '/',
        ...options
    });
};

/**
 * Serve React App
 * Serve the React app for any non-API, non-docs route.
 */
export const serveReactAppFullPathGet = <ThrowOnError extends boolean = false>(options: Options<ServeReactAppFullPathGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServeReactAppFullPathGetResponses, ServeReactAppFullPathGetErrors, ThrowOnError>({
        url: '/{full_path}',
        ...options
    });
};